export default {
  admin: {
    dashboard: "/Dashboard",
    listStores: "/Store",
    storeSubscriptions: "/Subscription/storeSubscriptions",
    subscriptionFeatures: "/Subscription/features",
    subscriptionFeaturesUpdate: "/Subscription/features/update",
    subscription: "/Subscription/{__id__}",
    subscriptionRenewal: "/Store/{__id__}/subscriptionRenewal",
    clearDailyVisits: "/Store/{__id__}/clearDailyVisits",
    store: "/Store/{__id__}",
    loginAsUser: "/UserManagment/LoginAsUser",
    changeUserPassword: "/UserManagment/ChangeUserPassword",
    categoryIcon: "/CategoryIcon",
    imageRequests: "/Store/imageRequests",
    imageRequestsChangeStatus: "/Store/imageRequests/changeStatus",
    pendingCategories: "/Store/pendingCategories",
    pendingCategoriesChangeStatus: "/Store/pendingCategories/changeStatus",
    pendingProducts: "/Store/pendingProducts",
    pendingProductsChangeStatus: "/Store/pendingProducts/changeStatus",
    pendingStores: "/Store/pendingStores",
    pendingStoresChangeStatus: "/Store/pendingStores/changeStatus",
    createStore: "/Store/create",
    replyTicket: "/tickets/{__id__}/reply",
    closeTicket: "/tickets/{__id__}/close",
    getTickets: "/tickets",
    getDetailsTickets: "/tickets/{__id__}",
    economicInfo: "/StoresEconomicInfos",
    economicInfoDetails: "/StoresEconomicInfos/{__id__}/details",
    economicInfoAccept: "/StoresEconomicInfos/{__id__}/accept",
    economicInfoReject: "/StoresEconomicInfos/{__id__}/reject",
    onlinePayments: "/orders/onlinePayments",
    reportOrders: "/orders/report",
    allOrders: "/orders/cashier",
    customers: "/customers",
    customerOrders: "/customers/{__id__}/orders",
    userManagment: "/UserManagment/getUsers",
    userManagmentRoles: "/UserManagment/roles",
    createNewUser: "/UserManagment/createNewUser",
    updateUser: "/UserManagment/{__id__}/UpdateUser",
    pendingLoyaltyLevels: "/Store/pendingLoyaltyLevels",
    pendingLoyaltyLevelsChangeStatus: "/Store/pendingLoyaltyLevels/changeStatus",
    smsManagement: "/smsManagement/templates",
    smsManagementStore: "/smsManagement/storeTemplates",
    smsManagementStoreAccept: "/smsManagement/storeTemplates/accept",
    smsChargesHistory: "/smsManagement/chargesHistory",
    sentMessagesHistory: "/smsManagement/sentMessages",
    smsSchedules: "/store/smsSchedules",
    smsChangeStatus: "/store/smsSchedules/changeStatus",
    smsSchedulesById: "/store/smsSchedules/{__id__}",
  },
};
